import ScrollToTop from './scrollToTop';

export default ScrollToTop;